export default {
    es: {
        profile: {
            title: 'Mi Perfil',
            subtitle: 'Actualiza tu información personal y preferencias del sistema',
            saveChanges: 'Guardar cambios',
            email: 'Correo electrónico',
            emailHint: 'Gestionado por el Administrador',
            firstName: 'Nombre',
            lastName: 'Apellidos',
            language: 'Idioma',
            joinedAt: 'Miembro desde',
            joinedAtHint: 'Fecha en que se creó tu cuenta',
            defaultDashboard: 'Dashboard por defecto',
            changePassword: 'Cambio de contraseña',
            currentPassword: 'Contraseña actual',
            newPassword: 'Nueva contraseña',
            confirmPassword: 'Confirmar contraseña',
            changePasswordBtn: 'Cambiar contraseña',
            required: 'Requerido',
            invalidEmail: 'Correo inválido',
            minPass: 'Mínimo 8 caracteres',
            passwordMismatch: 'No coinciden',
            saveSuccess: 'Perfil actualizado correctamente',
            saveError: 'Error al actualizar perfil',
            passwordWarning: 'Las contraseñas no coinciden',
            passwordSuccess: 'Contraseña actualizada correctamente',
            passwordError: 'Error al cambiar contraseña',
        },
    },
    en: {
        profile: {
            title: 'My Profile',
            subtitle: 'Update your personal information and system preferences',
            saveChanges: 'Save changes',
            email: 'Email address',
            emailHint: 'Managed by the Administrator',
            firstName: 'First name',
            lastName: 'Last name',
            language: 'Language',
            joinedAt: 'Member since',
            joinedAtHint: 'Date your account was created',
            defaultDashboard: 'Default dashboard',
            changePassword: 'Change password',
            currentPassword: 'Current password',
            newPassword: 'New password',
            confirmPassword: 'Confirm password',
            changePasswordBtn: 'Change password',
            required: 'Required',
            invalidEmail: 'Invalid email',
            minPass: 'Minimum 8 characters',
            passwordMismatch: 'Passwords do not match',
            saveSuccess: 'Profile updated successfully',
            saveError: 'Error updating profile',
            passwordWarning: 'Passwords do not match',
            passwordSuccess: 'Password updated successfully',
            passwordError: 'Error changing password',
        },
    },
}
